import { WeekView } from '@devexpress/dx-react-scheduler-material-ui';
import type { Theme } from '@mui/material/styles';
import { makeStyles } from '@mui/styles';
import React from 'react';

import { useIsMobile } from '@hooks/useIsMobile';

const useStyles = makeStyles((theme: Theme) => ({
  normalCellOverride: {
    backgroundColor: theme.palette.common.accentLightblue || '#e0f7fa',
  },
  shadedCellOverride: {
    backgroundColor: theme.palette.background.default || '#f5f5f5',
  },
}));

const TimeTableCell = ({ ...props }: WeekView.TimeTableCellProps) => {
  const classes = useStyles();
  const isMobile = useIsMobile();
  const { isShaded } = props;

  return (
    <WeekView.TimeTableCell
      {...props}
      className={
        isShaded ? classes.shadedCellOverride : classes.normalCellOverride
      }
      style={{
        width: isMobile ? '150px' : 'auto',
      }}
    />
  );
};

export default TimeTableCell;
